import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FormErrors } from '../../inc/error-form';
import { GetText, ReplaceInsText, ReplaceText } from '../../config/helper';
import { FaCircleCheck, FaArrowRight } from 'react-icons/fa6';

const authKey = global.config.kindcode.training[23]+global.config.authBearerKey;
const authKey2 = global.config.kindcode.training[3]+global.config.authBearerKey;

function getCategoryList(type,usedfor) {
    return new Promise((resolve) => {
      var dataText ='{"keyword":"","pageShow":"10","usageFor":"'+usedfor+'","type":"'+type+'"}';
      var dataSend = JSON.parse(dataText);
      fetch(global.config.urlLink+"/categorylist", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Authorization': authKey2
        }, 
        body : JSON.stringify(dataSend)
      }).then(response => {
        if(response.status === 200) {
          return response.json();
        } else {
          console.log('Something happened wrong');
        }
      }).then(resultJson => {
        if(resultJson.status === "200") {
            if(resultJson.values.length > 0) {
                var result = resultJson.values.filter(ty => ty.content.categoryType.trim() === type.trim());
                resolve(result);  
            } else {
                resolve([])
            }
          
        } else {
          resolve([])
        }
      });
    });
  }

async function getAllDatas(type,usedfor) {
    const categoryresult = getCategoryList(type,usedfor);

    const [thing1] = await Promise.all([categoryresult]);
    var arrReturnValue = {};
    arrReturnValue.categorylist = thing1;
    return arrReturnValue;
}

export default class PromptForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      action: '',
      activePage: '',
      member_id: localStorage.getItem('doc_id'),
      member_email: "",
      prompt_id: "",
      prompt_title: "",
      prompt_description: "",
      prompt_content: "",
      prompt_category: "",
      prompt_status: "",
      prompt_type: "",
      prompt_category_list: [],
      formErrors: { prompt_title: '', prompt_description: '', prompt_content: '', prompt_category: '', prompt_status: '', prompt_type: ''},
      prompttitleValid: false,
      promptdescriptionValid: false,
      promptcontentValid: false,
      promptcategoryValid: false,
      promptstatusValid: false,
      prompttypeValid: false,
      formValid: false,
      input_disabled: true,
      success_msg: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleUserInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }
  handleUserSelect = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({[name]: value},
        () => { this.validateField(name, value)});
  }
  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let prompttitleValid = this.state.prompttitleValid;
    let promptdescriptionValid = this.state.promptdescriptionValid;
    let promptcontentValid = this.state.promptcontentValid;
    let promptcategoryValid = this.state.promptcategoryValid;
    let promptstatusValid = this.state.promptstatusValid;
    let prompttypeValid = this.state.prompttypeValid;
    
    switch(fieldName) {
        case 'prompt_title': 
            prompttitleValid = value.trim().length > 0;
            fieldValidationErrors.prompt_title = prompttitleValid ? '' : 'title need to be filled';
            break;
        case 'prompt_description': 
            promptdescriptionValid = value.trim().length > 0;
            fieldValidationErrors.prompt_description = promptdescriptionValid ? '' : 'description need to be filled';
            break;
        case 'prompt_content': 
            promptcontentValid = value.trim().length > 0;
            fieldValidationErrors.prompt_content = promptcontentValid ? '' : 'prompt need to be filled';
            break;
        case 'prompt_category': 
            promptcategoryValid = value.trim().length > 0;
            fieldValidationErrors.prompt_category = promptcategoryValid ? '' : 'category need to be filled';
            break;
        case 'prompt_status': 
            promptstatusValid = value.trim().length > 0;
            fieldValidationErrors.prompt_status = promptstatusValid ? '' : 'visibility need to be filled';
            break;
        case 'prompt_type': 
            prompttypeValid = value.trim().length > 0;
            fieldValidationErrors.prompt_type = prompttypeValid ? '' : 'type need to be filled';
            break;
        default:
            break;
    }
    
    this.setState({formErrors: fieldValidationErrors,
                    prompttitleValid: prompttitleValid,
                    promptdescriptionValid: promptdescriptionValid,
                    promptcontentValid: promptcontentValid,
                    promptcategoryValid: promptcategoryValid,
                    promptstatusValid: promptstatusValid,
                    prompttypeValid: prompttypeValid
                }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.prompttitleValid && this.state.promptdescriptionValid && this.state.promptcontentValid && this.state.promptcategoryValid && this.state.promptstatusValid && this.state.prompttypeValid });
  }

  errorClass(error) {
    return(error.length === 0 ? '' : 'has-error');
  }

  handleSubmit(e) {
    e.preventDefault();
    if(this.state.prompt_title !== '' && this.state.prompt_content !== '' && this.state.prompt_category !== '' && this.state.prompt_status !== '') {
        document.getElementById('loading-area').style.display = 'block'; 
        var urlFetch, datatext;
        var promptTitle,promptDescription,promptContent,promptCategory,promptStatus;
        if(this.textInputPromptTitle.value === '') { promptTitle = this.state.prompt_title; } else { promptTitle = this.textInputPromptTitle.value; }
        if(this.textInputPromptCategory.value === '') { promptCategory = this.state.prompt_category; } else { promptCategory = this.textInputPromptCategory.value; }
        if(this.textInputpromptStatus.value === '') { promptStatus = this.state.prompt_status; } else { promptStatus = this.textInputpromptStatus.value; }
        
        if(this.textInputPromptDescription.value === '') { promptDescription = this.state.prompt_description; } else { promptDescription = this.textInputPromptDescription.value; }
        promptDescription = ReplaceInsText(promptDescription);
        if(this.textInputPromptContent.value === '') { promptContent = this.state.prompt_content; } else { promptContent = this.textInputPromptContent.value; }
        promptContent = ReplaceInsText(promptContent);
            
        var urlFetch = global.config.urlLink;
        var datatext='{';
        datatext += '"prompt_title":"'+promptTitle+'","prompt_description":"'+promptDescription+'","prompt_content":"'+promptContent+'","prompt_category":'+promptCategory+',"prompt_status":"'+promptStatus+'","prompt_type":"'+this.state.prompt_type+'"';
        if(this.state.action === "edit") {
            datatext +=',"prompt_id":"'+this.state.prompt_id+'","form_id":"form-edit"';
            urlFetch +='/promptedit';
        } else {
            datatext +=',"form_id":"form-add"';
            urlFetch +='/promptadd';
        }
        datatext += '}'

        var data = JSON.parse(datatext);
        fetch(urlFetch, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Authorization': authKey,
            }, body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) 
                return res.json() 
        }).then( resJson => {
            if(resJson.status === '200') {
                var docId = resJson.values;
                this.setState({ 
                    prompt_id: docId,
                    success_msg: true
                  });
            } else {
                console.log('Something happened wrong');
            }

            document.getElementById('loading-area').style.display = 'none'; 
        }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
        });
    
    } else {
        var arrfieldName = ['prompt_title','prompt_content','prompt_category','prompt_status'];
        var arrvalue = [this.textInputPromptTitle.value,this.textInputPromptContent.value,this.textInputPromptCategory.value,this.textInputpromptStatus.value];
        for(var ck in arrfieldName) {
            this.validateField(arrfieldName[ck], arrvalue[ck]);
        }
    }
  }

  componentDidMount() {
    var content = this.props.value;
    var data = {}; 
    if(content.data !== undefined) { data = content.data; }
    var promoType = global.config.specialCategory.filter(ty => ty.link.trim() === content.currpage.trim());
    var promoTypeResult = promoType.length > 0? promoType[0].value : '';
    
    getAllDatas(promoTypeResult,"prompt").then((response) => {
        this.setState({
            action: data.id !== undefined? 'edit' : 'add',
            activePage: content.currpage,
            prompt_category_list: response.categorylist,
            prompt_id: data.id !== undefined? data.id : '',
            prompt_title: data.promptSubject !== undefined? data.promptSubject : '',
            prompt_description: data.promptDescription !== undefined? ReplaceText(data.promptDescription) : '',
            prompt_content: data.promptContent !== undefined? ReplaceText(data.promptContent) : '',
            prompt_category: data.promptCategoryId !== undefined? '{"id":"'+data.promptCategoryId+'","name":"'+data.promptCategoryName.trim()+'"}' : '',
            prompt_status: data.promptStatus !== undefined? data.promptStatus : '',
            prompt_type: data.promptType !== undefined? data.promptType : promoTypeResult,
            formErrors: { prompt_title: '', prompt_description: '', prompt_content: '', prompt_category: '', prompt_status: '', prompt_type: ''},
            input_disabled: false
        });
    });
  }

  render() {
    return (
        <div className="container mb-4">
          <div id="prompt-form">
             {
                this.state.success_msg === true ? (
                    <div className="p-4 mb-5  w-100 d-flex justify-content-center"> 
                        <div className="row">
                          <div className="col-lg-2 d-flex justify-content-center">
                            <FaCircleCheck color="green" fontSize="80px" className="mt-2"/>
                          </div>
                          <div className="col-lg-10">
                            <div  className="mt-1 ms-2 fs-3">{GetText()? "Berhasil dikirim" : "Success submitted"}</div>
                            <div  className="mt-2 ms-2 fs-6">{GetText()? "Terima kasih atas kesediaan anda untuk berbagi prompt Anda." : "Thank you for sharing your prompt."} </div>
                            <div  className="mt-4 ms-2 fs-6">
                                <span className="link-more" onClick={() => window.location.href=global.config.urlHost+"/"+this.state.activePage+"/prompt"}>{GetText() ? "Lihat Lainnya" : "View More"} <FaArrowRight/></span>
                            </div>
                          </div>
                        </div>
                  </div>  
                ) : (
                <>
                <div className="mt-1">
                    <p className='fs-6'>{GetText() ? "Bagikan prompt menarik Anda selama menggunakan Google Gemini Atau saat mengikuti pelatihan Anda disini." : "Share your interesting prompt while using Google Gemini or while taking your training here."}</p>
                </div>
                
                <div className="mt-4">
                    <div >
                    <form onSubmit={this.handleSubmit}>
                        <div className="mt-3">
                            <label htmlFor="prompt_title">{GetText()? "Judul" : "Title"}</label>
                            <div className="mt-1">
                                <input type="text" className="form-control" name="prompt_title"
                                    placeholder={GetText()? "masukkan judul prompt anda" : "input your prompt title"}
                                    value={this.state.prompt_title}
                                    onChange={this.handleUserInput}  
                                    ref={(input) => this.textInputPromptTitle = input}
                                    disabled={this.state.input_disabled}
                                    autoFocus
                                    />
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.prompt_title}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="prompt_description">{GetText()? "Keterangan Singkat" : "Short Description"}</label>
                            <div className="mt-1">
                                <textarea name="prompt_description" className="form-control" 
                                        rows={3} 
                                        placeholder={GetText()? "masukkan penjelasan singkat mengenai hasil dari prompt anda" : "input your short description about your prompt result"}
                                        value={this.state.prompt_description} 
                                        onChange={this.handleUserInput} 
                                        ref={(input) => this.textInputPromptDescription= input}
                                        disabled={this.state.input_disabled}
                                        maxlength="500"/>
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.prompt_description}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="prompt_content">{GetText()? "Prompt Anda" : "Your Prompt"}</label>
                            <div className="mt-1">
                                <textarea name="prompt_content" className="form-control" 
                                        rows={3} 
                                        placeholder={GetText()? "masukkan prompt anda" : "input your prompt"}
                                        value={this.state.prompt_content} 
                                        onChange={this.handleUserInput} 
                                        ref={(input) => this.textInputPromptContent= input}
                                        disabled={this.state.input_disabled}
                                        maxlength="500"/>
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.prompt_content}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="prompt_category">{GetText()? "Kategori" : "Category"}</label>
                            <div className="mt-1">
                                <select name="prompt_category" className="form-control" 
                                            value={this.state.prompt_category} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputPromptCategory = input}
                                            disabled={this.state.input_disabled}
                                        >
                                        <option value="" key="C0">-- please select --</option>
                                        {
                                            this.state.prompt_category_list.length > 0 && (
                                                this.state.prompt_category_list.map((category_item, c) => {
                                                    var opt_value = '{"id":"'+category_item.docid+'","name":"'+category_item.content.categoryName+'"}';
                                                    return(<option value={opt_value} key={"C"+c}>{category_item.content.categoryName}</option>)
                                                })
                                            )
                                        }
                                </select>
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.prompt_category}/>  }</div>
                            </div>
                        </div>
                        <div className="mt-3">
                            <label htmlFor="prompt_status">{GetText()? "Visibilitas" : "Visibility"}</label>
                            <div className="mt-1">
                                <select name="prompt_status" className="form-control" 
                                            value={this.state.prompt_status} 
                                            onChange={this.handleUserSelect}
                                            ref={(input) => this.textInputpromptStatus = input}
                                            disabled={this.state.input_disabled}
                                        >
                                        <option value="" key="S0">-- please select --</option>
                                        <option value={global.config.promptStatus[0]} key="S1">{global.config.promptStatus[0]}</option>
                                        <option value={global.config.promptStatus[1]} key="S2">{global.config.promptStatus[1]}</option>
                                </select>
                                <div className="mt-1">{ <FormErrors formErrors={this.state.formErrors.prompt_status}/>  }</div>
                            </div>
                        </div>
                        
                    
                        <div className="mt-4 mb-3">
                            <Button variant="primary" id="submit" type="submit" style={{ width: "100%", marginTop: "20px" }}>Submit</Button>
                        </div>
                    </form>
                    </div>
                </div>
                </>
                )
              }
                   
          </div>
          <div id="loading-area" className="d-none loading"></div> 
        </div>
    );
  }
}
